import React from 'react';

import {
  EditLectureContentForm,
  LECTURE_CONTENT_OPTIONS,
} from 'features/classCreation';
import EditableSection from 'components/EditableSection';
import Field from 'components/Field';
import SbatGroupLectureContentChip from '../SbatGroupLectureContentChip';

function LectureDetails({ sbatGroup }) {
  const { academy_topic: academyTopic } = sbatGroup || {};
  const { lecture_contents: lectureContents } = academyTopic || {};

  return (
    <Field
      label="Lecture Details"
      labelClassName="m-b-xs"
    >
      <div className="m-b-s">
        {Object.keys(LECTURE_CONTENT_OPTIONS).map((contentType) => (
          <SbatGroupLectureContentChip
            sbatGroup={sbatGroup}
            contentType={contentType}
            title={LECTURE_CONTENT_OPTIONS[contentType].label}
            key={contentType}
          />
        ))}
      </div>
      {lectureContents.map((lectureContent) => {
        const label =
          LECTURE_CONTENT_OPTIONS[lectureContent.content_type].label;

        return (
          <EditableSection
            canEdit
            title={label}
            className="m-b-s"
            key={lectureContent.id}
          >
            {(editableProps) => (
              <EditLectureContentForm
                {...editableProps}
                academyTopicId={academyTopic.id}
                lectureContent={lectureContent}
                label={label}
              />
            )}
          </EditableSection>
        );
      })}
    </Field>
  );
}

export default LectureDetails;
